import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../admin/app';
import FormModal from '../../common/components/FormModal';
import Button from '../../common/components/Button';
import Badge from '../../common/components/Badge';
import Group from '../../common/models/Group';
import ItemList from '../../common/utils/ItemList';
import Switch from '../../common/components/Switch';
import Stream from '../../common/utils/Stream';
import extractText from '../../common/utils/extractText';
import ColorPreviewInput from '../../common/components/ColorPreviewInput';
import Form from '../../common/components/Form';
/**
 * The `EditGroupModal` component shows a modal dialog which allows the user
 * to create or edit a group.
 */
export default class EditGroupModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "group", void 0);
    _defineProperty(this, "nameSingular", void 0);
    _defineProperty(this, "namePlural", void 0);
    _defineProperty(this, "icon", void 0);
    _defineProperty(this, "color", void 0);
    _defineProperty(this, "isHidden", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.group = this.attrs.group || app.store.createRecord('groups');
    this.nameSingular = Stream(this.group.nameSingular() || '');
    this.namePlural = Stream(this.group.namePlural() || '');
    this.icon = Stream(this.group.icon() || '');
    this.color = Stream(this.group.color() || '');
    this.isHidden = Stream(this.group.isHidden() || false);
  }
  className() {
    return 'EditGroupModal Modal--small';
  }
  title() {
    return m('[', null, !!(this.color() || this.icon()) && m(Badge, {
      icon: this.icon(),
      color: this.color()
    }), ' ', this.namePlural() || app.translator.trans('core.admin.edit_group.title'));
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, null, this.fields().toArray()));
  }
  fields() {
    const items = new ItemList();
    items.add('name', m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('core.admin.edit_group.name_label')), m("div", {
      className: "StackedFormControl EditGroupModal-name-input"
    }, m("input", {
      className: "FormControl",
      placeholder: app.translator.trans('core.admin.edit_group.singular_placeholder'),
      bidi: this.nameSingular
    }), m("input", {
      className: "FormControl",
      placeholder: app.translator.trans('core.admin.edit_group.plural_placeholder'),
      bidi: this.namePlural
    }))), 30);
    items.add('color', m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('core.admin.edit_group.color_label')), m(ColorPreviewInput, {
      placeholder: "#aaaaaa",
      bidi: this.color
    })), 20);
    items.add('icon', m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('core.admin.edit_group.icon_label')), m("div", {
      className: "helpText"
    }, app.translator.trans('core.admin.edit_group.icon_text', {
      a: m("a", {
        href: app.refs.fontawesome,
        tabindex: "-1"
      })
    })), m("input", {
      className: "FormControl",
      placeholder: "fas fa-bolt",
      bidi: this.icon
    })), 10);
    items.add('hidden', m("div", {
      className: "Form-group"
    }, m(Switch, {
      state: this.isHidden(),
      onchange: this.isHidden
    }, app.translator.trans('core.admin.edit_group.hide_label'))), 10);
    items.add('submit', m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      type: "submit",
      className: "Button Button--primary EditGroupModal-save",
      loading: this.loading
    }, app.translator.trans('core.admin.edit_group.submit_button')), this.group.exists && this.group.id() !== Group.ADMINISTRATOR_ID && m("button", {
      type: "button",
      className: "Button EditGroupModal-delete",
      onclick: this.deleteGroup.bind(this)
    }, app.translator.trans('core.admin.edit_group.delete_button'))), -10);
    return items;
  }
  submitData() {
    return {
      nameSingular: this.nameSingular(),
      namePlural: this.namePlural(),
      color: this.color(),
      icon: this.icon(),
      isHidden: this.isHidden()
    };
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    this.group.save(this.submitData(), {
      errorHandler: this.onerror.bind(this)
    }).then(this.hide.bind(this)).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  deleteGroup() {
    if (confirm(extractText(app.translator.trans('core.admin.edit_group.delete_confirmation')))) {
      this.group.delete().then(() => m.redraw());
      this.hide();
    }
  }
}
flarum.reg.add('core', 'admin/components/EditGroupModal', EditGroupModal);